module.exports = __webpack_public_path__ + "img/two.1842eaa9.svg";